export default function ScoreBar({ score, max = 10 }) {
  return (
    <div style={{ minWidth: 80 }}>
      <span style={{ fontWeight: 700, color: 'var(--color-primary)', fontSize: '0.9rem' }}>{score}/{max}</span>
      <div className="score-bar">
        <div className="score-bar-fill" style={{ width: `${(score/max)*100}%` }} />
      </div>
    </div>
  );
}
